import { css } from '@emotion/react'
import styled from '@emotion/styled'

const Legend = styled.legend<{ required?: boolean }>`
	margin-bottom: ${({ theme }) => theme.spaces.space4};
	${({ theme }) => theme.typography.paragraphMedium}

	${({ required, theme }) =>
		required &&
		css`
			&::after {
				content: '*';
				margin-left: 4px;
				color: ${theme.colorPalette.red[500]};
			}
		`}
`

export default Legend
